
import { MapLocation } from '@/types/location';

// Snooker Center Locations
export const snookerCenters: MapLocation[] = [
  {
    id: 58001,
    name: "Snooker Center - Riyadh (As Sulimaniyah)",
    type: "Game Center",
    devices: 3,
    coordinates: [24.702690308646766, 46.69724022024108],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "17-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
